import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useAsync, useRoute, useRouter, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useAuth } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getFollowerStore } from "@/store/follower";
import { getProfilesStore } from "@/store/profiles";
import { hasValidTooltipReferral } from "@/utils/sessionstorage";
import { TOOLTIP_REFERRER_DISCOVER_PAGE_FOLLOW_TIMESTAMP } from "@/utils/sessionstorage/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkFollowButton',
  props: {
  profileId: { type: String, required: true },
  large: { type: Boolean, required: false, default: false },
  isRunway: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;



const showUnfollowPrompt = ref(false);
const amplitude = useAmplitude();
const auth = useAuth();
const store = useStore();
const route = useRoute();
const router = useRouter();
async function fetch() {
  if (auth.loggedIn) {
    await getFollowerStore(store).fetchFollowsByProfileId(props.profileId);
  }
}

useAsync(() => fetch(), "LtkFollowButton Fetch");

const displayName = computed(() => {
  return getProfilesStore(store).profiles[props.profileId]?.displayName;
});

const following = computed(() => {
  if (auth.loggedIn) {
    return Boolean(getFollowerStore(store).followedProfiles[props.profileId]);
  }
  return false;
});

async function onFollow() {
  if (auth.loggedIn) {
    if (following.value) {
      showUnfollowPrompt.value = true;
      sendEvent("/unfollow");
    } else {
      await getFollowerStore(store).follow(props.profileId);
      sendEvent("/follow");
    }
  } else {
    sessionStorage.setItem("follow-profile", props.profileId);
    getFollowerStore(store).setLoggedOutFollowProfile(props.profileId);
    getAmplitudeStore(store).setReferringComponent(setReferringComponent()["referring-component"]);
    router.push({ path: "/signup", query: { "shopltk-signup-prompt": "discover" } });
  }
}

function onUnfollowPromptClose() {
  showUnfollowPrompt.value = false;
  sendEvent("/unfollow/cancel");
}

async function onUnfollowPromptContinue() {
  if (auth.loggedIn) {
    showUnfollowPrompt.value = false;
    await getFollowerStore(store).unfollow(props.profileId);
    sendEvent("/unfollow/confirm");
  }
}

function setReferringComponent() {
  switch (route.value.name) {
    case "home-for-you":
      return { "referring-component": "home - for you page feed" };
    case "home-following":
      return { "referring-component": "home - following page feed" };
    case "categories-category":
      return { "referring-component": "category detail page feed" };
    case "collections-hash":
      return { "referring-component": "wishlist details page" };
    case "explore-displayName":
      // The naming of this key can be reused for other routes if required
      if (hasValidTooltipReferral(TOOLTIP_REFERRER_DISCOVER_PAGE_FOLLOW_TIMESTAMP)) {
        return { "referring-component": "creator shop - follow tooltip" };
      }
      return { "referring-component": "creator shop" };
    case "explore-displayName-posts-id":
      return { "referring-component": "post page" };
    case "explore-displayName-giftguides-id":
      return { "referring-component": "gift guide detail page", "product-set-subtype": "GIFT_GUIDE" };
    case "account-favorites-products":
      return { "referring-component": "account-favorites-products" };
    case "account-favorites-posts":
      return { "referring-component": "account-favorites-posts" };
    case "search":
      return {
        "referring-component": `search-toggle-${
          route.value.query.type === "profile" ? "influencers" : route.value.query.type
        }`,
      };
    case "ltk-shopping-app":
      return { "referring-component": "landing page" };
    case "ltk-chat":
      return { "referring-component": "chat landing page" };
    default:
      return { "referring-component": "" };
  }
}

function sendEvent(event: AmplitudeEventType) {
  amplitude?.sendEvent(event, setReferringComponent());
}

return { __sfc: true,props, showUnfollowPrompt, amplitude, auth, store, route, router, fetch, displayName, following, onFollow, onUnfollowPromptClose, onUnfollowPromptContinue, setReferringComponent, sendEvent }
}

})